import React, { memo, useContext, useEffect, useRef, useState } from 'react';
import { PrintOutlined } from '@mui/icons-material';
import { Box, Button, Container, Typography, TextField, MenuItem } from '@mui/material';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useReactToPrint } from 'react-to-print';
import GradientLoader from '../../components/CommanComponents/GradientLoader';
import { QRCodeCanvas } from 'qrcode.react';
import { DataContext } from '../../context/DataContext';

/* ---------------- QR ITEM ---------------- */

const QRItem = memo(({ id, showText }) => (
  <div className="qr-item">
    {showText && (<div className="qr-text" style={{fontSize: '0.6rem',marginBottom: '2px',textAlign: 'center'}}>{id}</div>)}
    <QRCodeCanvas value={id} size={90} />
  </div>
));

const PrintPhysicalCardQr= () => {

    const qrRef    = useRef();
    const navigate = useNavigate();
    const [params] = useSearchParams();

    const {loginData } = useContext(DataContext);
    const store_id = params.get("store") || loginData?.store_info?.store_id || "STORE"; 

    const [loading,   setLoading]   = useState(false);
    const [datar,     setDatar]     = useState([]);
    const [cardCount, setCardCount] = useState(() => {
      const qty = Math.floor(Number(params.get("qty") || 0));
      return qty > 0 ? Math.min(500, qty) : 1;
    });   
    const [qrIdPrint, setQrIdPrint] = useState(false);      

    /* ---------------- PRINT CONFIG ---------------- */
    const handlePrint = useReactToPrint({
        contentRef: qrRef,
        documentTitle: "QR Cards A3",
        pageStyle: `
          @page { size: A3 landscape; margin: 5mm; }
          body  { -webkit-print-color-adjust: exact !important; color-adjust: exact !important; background: white !important; }
          .MuiCard-root { page-break-inside: avoid; break-inside: avoid; }
        `,
    });

    /* ---------------- ID GENERATOR ---------------- */
    const generateId = (length = 6) => 
    {
        const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
        let result = "";

        for (let i = 0; i < length; i++) { result += chars.charAt(Math.floor(Math.random() * chars.length)); }

        const now    = new Date();
        const day    = String(now.getDate()).padStart(2, "0");
        const hour   = String(now.getHours()).padStart(2, "0");
        const minute = String(now.getMinutes()).padStart(2, "0");

        return `${result}${day}${hour}${minute}`;

    };

    /* ---------------- GENERATE QR LIST ---------------- */
    useEffect(() => 
    {
        let mounted = true;
        const generate = () => 
        {
            setLoading(true);

            if (cardCount <= 0) 
            {
                setDatar([]);
                setLoading(false);
                return;
            }

            
            const list = [];
            for (let i = 1; i <= cardCount; i++) 
            {
                const baseTime = generateId(6);
                const uniqueId = `${store_id}${baseTime}${i}`;

                list.push({ id: uniqueId });
            }
            
            setTimeout(() => 
            {
                if (mounted) setDatar(list);
                setLoading(false);
            }, 80);
        };

      generate();
      return () => { mounted = false; };
      
    }, [cardCount, store_id]);

    /* ---------------- CLEAR ---------------- */
    const clearFun = () => 
    {
        setCardCount(1);
        setQrIdPrint(false);
    };

  return (
    <Box>
      <Container>

          {/* BACK BUTTON */}
          <Box sx={{ display: 'flex', justifyContent: 'flex-start', mb: 2 }}>
            <Button variant="contained" sx={{ backgroundColor: '#000000', color: '#ffffff' }} onClick={() => navigate(-1)}> Back </Button>
          </Box>

          {/* TITLE */}
          <Typography variant="h6"  gutterBottom sx={{ background: 'linear-gradient(195deg, #49a3f1, #1A73E8)', p: 1, color: '#ffffff',
              borderRadius: '4px', mb: 3, display: 'flex', alignItems: 'center',}}> <PrintOutlined sx={{ mx: 1 }} /> Print Physical Card
          </Typography>
          
          {/* PRINT BUTTON */}
          <Box sx={{ display: 'flex', justifyContent: 'end', mb: 2 }}>
            <Button variant="contained" sx={{ background: 'linear-gradient(195deg, #42424a, #191919)', color: '#ffffff', ml:1}}
              onClick={handlePrint} > <PrintOutlined sx={{ mx: 1 }} /> Print </Button >      
          </Box>
       
          {/* FILTER */}
          <Box sx={{ display: 'flex',flexWrap:'wrap', gap: 2, mb: 2 }}>        
            <TextField  label="Card Count" value={cardCount} 
                onChange={(e) => { const v = Math.min(500, Number(e.target.value.replace(/\D/g, "")) || 0);
                    setCardCount(v);
                }} sx={{ minWidth: 160 }} /> 

            <TextField  select label="Limit" value={qrIdPrint} onChange={(e) => { setQrIdPrint(e.target.value);}} sx={{ minWidth: 140, }}>
                  <MenuItem value={true}>Yes</MenuItem>
                  <MenuItem value={false}>No</MenuItem>
            </TextField>
              
            <Button variant="outlined" color="error" sx={{ height: 56 }} onClick={() => {clearFun()}}> Clear Filter </Button>
          
          </Box>

          <Box ref={qrRef} className="print-grid" sx={{ display: "grid", gridTemplateColumns: "repeat(13, 1fr)",
              gridTemplateRows: "repeat(13, auto)", gap: "1mm", p: "0mm",boxSizing: "border-box",}} >

              {datar.length > 0 ? (datar.map((item) => ( <QRItem key={item.id} id={item.id} showText={qrIdPrint} /> )) ) : ( 
                  <Typography sx={{ p: 3, color: "#888" }}> No QR data available. </Typography> )}
                  
          </Box>
            
      </Container>

       {loading && <GradientLoader text="Loading" />}        {/* // loader */}
    </Box>
  );

}

export default PrintPhysicalCardQr;